import { render, staticRenderFns } from "./area.vue?vue&type=template&id=1ac074de&scoped=true"
import script from "./area.vue?vue&type=script&lang=js"
export * from "./area.vue?vue&type=script&lang=js"
import style0 from "./area.vue?vue&type=style&index=0&id=1ac074de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac074de",
  null
  
)

export default component.exports